import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { useToast } from '../hooks/use-toast';
import { sendEnquiry } from '../lib/sendEnquiry';

export default function EnquiryDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const ok = await sendEnquiry(form, 'Quick Enquiry');
    setSubmitting(false);
    toast({
      title: ok ? 'Enquiry sent' : 'Enquiry saved',
      description: ok
        ? 'Our team will get back to you shortly. Thank you!'
        : 'Could not reach mail server right now. We have saved your enquiry locally — please call us at +91-9911565091.',
    });
    setForm({ name: '', phone: '', email: '', message: '' });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-wide text-[#e67e00]">Request A Call Back</DialogTitle>
          <DialogDescription>Fill the form and our team will reach out soon.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <div>
            <Label htmlFor="name">Name</Label>
            <Input id="name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label htmlFor="phone">Phone</Label>
              <Input id="phone" required value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
          </div>
          <div>
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" rows={3} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} />
          </div>
          <button type="submit" disabled={submitting} className="btn-brand w-full justify-center disabled:opacity-60">
            {submitting ? 'Sending...' : 'Submit Now'}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
